import { ExternalServiceClientType, ExternalServiceGenderType } from '../enums/externalService';
import Gender from '../enums/gender';
import { countriesWithCodes } from './countries-and-codes';
import { get, toString } from 'lodash';
import {sanitizeString} from "./stringFormatting";

const genderMapper = {
  [Gender.female]: ExternalServiceGenderType.Female,
  [Gender.male]: ExternalServiceGenderType.Male,
  [Gender.none]: ExternalServiceGenderType.None,
  [Gender.nonBinary]: ExternalServiceGenderType.NonBinary,
};

const clientTypeMapper = {
  [Gender.female]: ExternalServiceClientType.Person,
  [Gender.male]: ExternalServiceClientType.Person,
  [Gender.nonBinary]: ExternalServiceClientType.Person,
  [Gender.none]: ExternalServiceClientType.Company,
};

const mapGenderToRequest = (gender) => genderMapper[gender];

const mapGenderToResponse = (sexCode) => {
  return Object.keys(genderMapper).find(key => genderMapper[key] !== undefined && genderMapper[key] === sexCode);
};

const mapClientTypeToRequest = (gender) => clientTypeMapper[gender];

const mapPhoneCountryCode = (codeNumber, defaultAlpha) => {
  const callingCode = parseInt(codeNumber).toString();
  const country = countriesWithCodes.find(country => country.callingCodes.includes(callingCode));

  return get(country, 'alpha2Code', defaultAlpha || 'AR') || defaultAlpha || 'AR';
};

const buildPersonDataFromClientResponse = (clientData) => {
  return {
    id: get(clientData, 'idNumber', ''),
    firstName: sanitizeString(get(clientData, 'firstName', '')),
    lastName : sanitizeString(get(clientData, 'lastName', '')),
    idType: get(clientData, 'idType', ''),
    phone: {
      countryCode: mapPhoneCountryCode(get(clientData, 'ddi', '')),
      full: toString(parseInt(get(clientData, 'phone', '')) || ''),
    },
    email: get(clientData, 'email', ''),
    gender: get(clientData, 'gender', ''),
  };
};

module.exports = {
  buildPersonDataFromClientResponse,
};
